class MediaViewPreference extends Backbone.Model {

    static options = {
        grid: 'grid',
        list: 'list'
    }

    defaults = {
        view: MediaViewPreference.options.grid
    }

    constructor(params) {
        super(params);

        this.set({
            view: Cookies.get('media-view-preference') || MediaViewPreference.options.grid
        });

        this.listenTo(this, 'change:view', (model, value) => {
            Cookies.set('media-view-preference', value, { httpOnly: false, expires: 365 });
        });
    }
}

export default MediaViewPreference;
